export default __webpack_public_path__ + "static/media/transcendGrowthImage.0cce4b88.jpg";